import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=2fa81080&scoped=true"
import script from "./NewDialog.vue?vue&type=script&lang=js"
export * from "./NewDialog.vue?vue&type=script&lang=js"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=2fa81080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa81080",
  null
  
)

export default component.exports